<template>
  <nav class="mb-20 flex flex-col px-4 bg-white shadow-lg">
    <div class="flex justify-between h-20 items-center">
      <div class="flex items-center">
        <router-link to="/">
          <img src="@/assets/logo.png" class="h-16" alt="Logo" />
        </router-link>
        <router-link to="/restaurants" class="text-xl ml-6" :class="{ hidden: !this.$store.state.isAuthenticated }">
          {{ $t('Restaurants') }}
        </router-link>
      </div>
      <button type="button" @click="handleChangeLanguage">
        <img v-show="$i18n.locale === 'es'" class="h-6" src="@/assets/britain.png" alt="British Flag" />
        <img v-show="$i18n.locale === 'en'" class="h-6" src="@/assets/panama.png" alt="Panamanian Flag" />
      </button>
      <a
        href="http://about.mesonera.com/"
        class="text-2xl ml-5 text-gray-700"
        :class="{ hidden: this.$store.state.isAuthenticated }"
      >
        {{ $t('About Us') }}
      </a>
      <router-link
        to="/login"
        class="text-2xl ml-5 text-gray-700"
        :class="{ hidden: this.$store.state.isAuthenticated }"
      >
        {{ $t('Login') }}
      </router-link>
      <div class="flex" v-if="this.$store.state.isAuthenticated">
        <router-link to="/cart" :class="{ hidden: !this.$store.state.isAuthenticated || this.$route.name == 'cart' }">
          <div class="relative">
            <div class="h-6 w-6 bg-red-700 absolute cart-notif rounded-full text-center text-white font-bold">
              {{ $store.state.cart.length }}
            </div>
            <eva-icon name="shopping-cart-outline" animation="pulse" width="40" height="40" fill="#4A5568"></eva-icon>
          </div>
        </router-link>
        <eva-icon
          :class="{ hidden: !this.$store.state.isAuthenticated }"
          class="ml-4"
          name="menu-outline"
          animation="pulse"
          width="40"
          height="40"
          fill="#4A5568"
          @click="open = !open"
        ></eva-icon>
      </div>
    </div>

    <ol v-show="open" class="flex flex-col text-2xl">
      <li class="h-12 mb-3" @click="handleLogout">
        <!-- <search-bar class="text-base" /> -->
        {{ $t('Logout') }}
      </li>
    </ol>
  </nav>
</template>

<script>
import { auth } from '@/firebase';

export default {
  name: 'NavBar',
  data() {
    return {
      open: false,
    };
  },
  methods: {
    handleChangeLanguage() {
      if (this.$i18n.locale === 'en') this.$i18n.locale = 'es';
      else if (this.$i18n.locale === 'es') this.$i18n.locale = 'en';
    },
    handleGoToMenu() {
      const restaurantId = localStorage.getItem('lastRestaurant');
      this.$router.push(`/restaurants/${restaurantId}`);
    },
    handleLogout() {
      auth.signOut();
      this.$toasted.success(this.$t('Logged out successfuly!'), {
        theme: 'bubble',
        position: 'top-center',
        duration: 3000,
      });
      this.$router.push('login');
    },
  },
};
</script>

<style>
.cart-notif {
  top: -15px;
  right: -15px;
}
</style>
